import React, { Component } from 'react';
import './Result.css';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import WeightBenefitsTabs from './WeightBenefitsTabs/WeightBenefitsTabs';
import CreateWeightlModal from './CreateWeightlModal/CreateWeightlModal';
import { ContentLowPriority } from 'material-ui/svg-icons';
import { debug } from 'util';
import AbilityToCompeteError from './AbilityToCompeteError/AbilityToCompeteError';
import jsPDF from 'jspdf';
import rasterizeHTML from 'rasterizehtml';


class Result extends Component {
    constructor(props) {
        super(props);
        this.state = {
            goNextStep: false,
            tabs: [],
            competeData: [],
            competitorsGroupsData: [],
            benefitsData: [],
            countCCWT: [],

        }
    }

    componentWillMount() {
        let customerSegmentData ={
            projectId: this.props.projectId,
            type: 'segmentation'
        }
        let competeData ={
            projectId: this.props.projectId,
            type: 'compete'
        }
        let challengeData = {
            type : "challenge",
            projectId : this.props.projectId,
        }

        let competitorsData = {
            projectId: this.props.projectId,
            type: 'competitors'
        }

        this.props.getCompetitorsGroups(competitorsData);
        this.props.getCustomerSegment(customerSegmentData);
        this.props.getCompete(competeData);
        this.props.getChallengeStatements(challengeData);
        //this.props.getBenefits(benefitData);
    }

    printPage = () => {
        let html = `<div>
                        <h2 style='font-size: 18px; color: #333333; margin: 0px 0px 0px 0px'>Results</h2>
                        <br/>
                        ${this.state.tabs
                          .map((tabsItem, tabsKey) => {
                            let countWT = 0;
                            let countCCWT = 0;
                            let countScore = 0;
                            let countConpenScore = [];
                            const groupId = this.state.tabs.find(
                              r => r.groupId === tabsItem.groupId
                            ).groupId;
                            const segmentId = this.state.tabs.find(
                              r => r.segmentId === tabsItem.segmentId
                            ).segmentId;
                            return `<div style=" width: 815px; margin-bottom: 20px;height: 300px; ">
                                <div style="margin-bottom: 20px; width: 100%">
                                    <div>
                                        ${tabsItem.groupName}
                                    </div>
                                </div>
                                <div style='width: 500px; float: left;border-right: 2px dashed'>
                                    <div style='width: 100%; height: 30px;'></div>
                                    <table style="width: 100%">
                                        <thead>
                                            <tr style='width: 100%'>
                                                <th style="font-size: 12px; width: 12.5%;">Benefits Sought</th>
                                                <th style="font-size: 12px; width: 12.5%;">WT</th>
                                                <th style="font-size: 12px; width: 12.5%;">Critical Capability</th>
                                                <th style="font-size: 12px; width: 12.5%;">CC WT</th>
                                                <th style="font-size: 12px; width: 12.5%;">Rating <br/> (1-10)</th>
                                                <th style="font-size: 12px; width: 12.5%;">Score</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            ${this.state.competeData &&
                                              !_.isEmpty(
                                                this.state.benefitsData
                                              ) &&
                                              this.state.competeData
                                                .map((i, index) => {
                                                  if (
                                                    tabsItem.groupId ===
                                                      i.groupId &&
                                                    tabsItem.segmentId ===
                                                      i.segmentId
                                                  ) {
                                                    let benefitName;
                                                    this.props.benefits.benefitsLadderData.Items[0].data.map(
                                                      item => {
                                                        if (
                                                          item.groupId ===
                                                          i.groupId
                                                        ) {
                                                          benefitName = item.benefits.find(
                                                            r =>
                                                              r.id ===
                                                                i.benefitId &&
                                                              r.important
                                                          );
                                                        }
                                                      }
                                                    );
                                                    // let benefitName = this.state.benefitsData.find(r => r.groupId === i.groupId && r.benefitId === i.benefitId);
                                                    return `<tr style="width: 100%">
                                                        <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                                            <div className='td-box' style='min-height: 50px'>
                                                                ${
                                                                  benefitName ? benefitName.name : i.name
                                                                }
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                                            <div className='td-box' style=" position : relative; min-height: 50px">
                                                                ${i.wt}
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                                            <div className='td-box' style='min-height: 50px'>
                                                                ${i.criticalCapacity
                                                                  .map(
                                                                    (
                                                                      critItem,
                                                                      index
                                                                    ) => {
                                                                      return `<div> ${
                                                                        critItem.text ? critItem.text : ''
                                                                      } </div>`;
                                                                    }
                                                                  ).join("")}
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                                            <div className='td-box' style='min-height: 50px'>
                                                            ${i.criticalCapacity
                                                              .map(
                                                                (
                                                                  critItem,
                                                                  index
                                                                ) => {
                                                                  let ccWt =
                                                                    i
                                                                      .criticalCapacity
                                                                      .length >
                                                                    1
                                                                      ? critItem.ccWt
                                                                      : critItem.ccWt;

                                                                  return `<div style="position: relative">
                                                                    ${ccWt}
                                                                </div>`;
                                                                }
                                                              ).join("")}
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 11px; width: 16%; text-align: center;  background: #f5f5f6">
                                                            <div className='td-box' style='min-height: 50px'>
                                                                ${i.criticalCapacity
                                                                  .map(
                                                                    (
                                                                      critItem,
                                                                      index
                                                                    ) => {


                                                                      let val = critItem.rating
                                                                        ? critItem.rating
                                                                        : "1";



                                                                      return `<div style="position: relative; ">
                                                                        ${val}

                                                                    </div>`;
                                                                    }
                                                                  ).join("")}
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                                            <div className='td-box' style='min-height: 50px'>
                                                                ${i.criticalCapacity
                                                                  .map(
                                                                    (
                                                                      critItem,
                                                                      index
                                                                    ) => {
                                                                      let valScore = critItem.rating
                                                                        ? +critItem.ccWt *
                                                                          +critItem.rating
                                                                        : +critItem.ccWt;
                                                                      countScore =
                                                                        +countScore +
                                                                        valScore;

                                                                      return `<div className='score-box' style="position: relative">
                                                                            ${valScore}
                                                                        </div>`;
                                                                    }
                                                                  ).join("")}
                                                            </div>
                                                        </td>
                                                    </tr>`;
                                                  }
                                                })
                                                .join("")}

                                            <tr style="width: 100%">
                                                <td style="font-size: 11px; width: 16%; text-align: center"></td>
                                                <td style="font-size: 11px; width: 16%; text-align: center">
                                                    <strong>

                                                    </strong>
                                                </td>
                                                <td style="font-size: 11px; width: 16%; text-align: center"></td>
                                                <td style="font-size: 11px; width: 16%; text-align: center">
                                                    <strong>

                                                    </strong>
                                                </td>
                                                <td style="font-size: 11px; width: 16%; text-align: center"></td>
                                                <td style="font-size: 11px; width: 16%; text-align: center">
                                                    <strong>
                                                        ${countScore}
                                                    </strong>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div style='width: 300px; float: left'>
                                    <div style='width: 300px; height: 30px; margin-left: 10px'>
                                    ${this.state.competeData.find(
                                      r =>
                                        r.groupId === tabsItem.groupId &&
                                        r.segmentId === tabsItem.segmentId
                                    ).competitorTotal &&
                                      _.uniqBy(
                                        this.state.competeData.find(
                                          r =>
                                            r.groupId === tabsItem.groupId &&
                                            r.segmentId === tabsItem.segmentId
                                        ).competitorTotal,
                                        "competitorId"
                                      )
                                        .map((item, index) => {
                                          return `<div style='width: 33%; float: left;'>
                                                ${this.state.competitorsGroupsData
                                                  .map((name, key) => {
                                                    if (
                                                      item.competitorId ===
                                                      name.competitorId
                                                    )
                                                      return name.competitorName;
                                                  }).join("")}
                                                </div>`;
                                        }).join("")}
                                    </div>
                                    <table style="width: 300px; margin-left: -8px">
                                        <thead style='width: 300px'>
                                            <tr style='width: 100%; padding: 0px;'>
                                                ${this.state.competitorsGroupsData
                                                  .map((name, key) => {
                                                    if (name.important) {
                                                      return `
                                                            <th style='width: 33.3%; padding: 0px;'>
                                                                <th style='width: 49%; font-size: 12px; padding: 0px; text-alight: center'>Rating <br/> (1-10)</th>
                                                                <th style='width: 49%; font-size: 12px; padding: 0px; text-alight: center'>Score</th>
                                                            </th>
                                                        `;
                                                    }
                                                  }).join("")}
                                            </tr>
                                        </thead>
                                        <tbody style="width: 100%">
                                            ${this.state.competeData &&
                                              !_.isEmpty(
                                                this.state.benefitsData
                                              ) &&
                                              this.state.competeData
                                                .map((i, index) => {
                                                  if (
                                                    tabsItem.groupId ===
                                                      i.groupId &&
                                                    tabsItem.segmentId ===
                                                      i.segmentId
                                                  ) {

                                                    return `<tr style="width: 100%">
                                                            ${this.state.competitorsGroupsData
                                                              .map(
                                                                (
                                                                  competitorsData,
                                                                  key
                                                                ) => {
                                                                  if (
                                                                    competitorsData.important
                                                                  ) {
                                                                    return `<td style='width: 33.3%'>
                                                                        <td style='width: 50%; font-size: 11px; text-align: center; background: #f5f5f6; height: 50px;padding: 15px 23px'>
                                                                        ${i.criticalCapacity
                                                                          .map(
                                                                            (
                                                                              critItem,
                                                                              index
                                                                            ) => {
                                                                              let defData = critItem.competitors
                                                                                ? critItem.competitors.find(
                                                                                    r =>
                                                                                      r.competitorId ===
                                                                                      competitorsData.competitorId
                                                                                  )
                                                                                : false;
                                                                              return `<div style="position: relative;">
                                                                            ${
                                                                              defData
                                                                                ? defData.rating
                                                                                : 1
                                                                            }
                                                                            </div>`;
                                                                            }
                                                                          )
                                                                          .join(
                                                                            ""
                                                                          )}
                                                                        </td>
                                                                        <td style='width: 50%; font-size: 11px; text-align: center; background: #f5f5f6;height: 50px'>
                                                                        ${i.criticalCapacity.map((critItem,index) => {

                                                                            let rateVal = critItem.competitors ? critItem.competitors.find(r => r.competitorId === competitorsData.competitorId) : { rating: '1' };


                                                                            let valScore = rateVal ? +critItem.ccWt * +rateVal.rating : +critItem.ccWt;


                                                                            let newVal = valScore ? valScore : critItem.ccWt;

                                                                            countConpenScore.push({
                                                                                score: valScore,
                                                                                competitorId: competitorsData.competitorId,
                                                                            })

                                                                              return `<div style='width: 100%; text-align: center; font-size: 11px; position: relative;'>
                                                                                ${
                                                                                  valScore
                                                                                    ? valScore
                                                                                    : critItem.ccWt
                                                                                }
                                                                            </div> `;
                                                                            }
                                                                          )
                                                                          .join(
                                                                            ""
                                                                          )}
                                                                        </td>

                                                                    </td>
                                                                    `;
                                                                  }
                                                                }
                                                              ).join("")}
                                                        </tr>`;
                                                  }
                                                }).join("")}
                                                <tr class='last-row'>
                                                    ${
                                                        this.state.competitorsGroupsData.map((competitorsData, key) => {
                                                            if (competitorsData.important) {
                                                                let val = 0;
                                                                countConpenScore.map((item, key) => {
                                                                    if (item.competitorId === competitorsData.competitorId) {
                                                                        val = val + +item.score
                                                                    }
                                                                })
                                                                return `<td className='parent-td'>
                                                                <td className='child-td'></td>
                                                                <td className=' child-td first-value'>
                                                                <strong>${val}</strong>
                                                                </td>
                                                            </td>`
                                                            }
                                                        }).join("")

                                                    }
                                                </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>`;
                          })
                          .join("")}
        </div>`;
    let w = window.open();
    w.document.write(html);
    w.print();
    w.close();
  }

    printDocument = (e) => {

        e.preventDefault();
        const canvas = document.createElement('canvas');
        canvas.height = 1000;
        canvas.width = 1500;
        // canvas.textAlign = "center";

        let html = `<div>
                        <h2 style='font-size: 18px; color: #333333; margin: 0px 0px 0px 0px'>Results</h2>
                        <br/>
                        ${this.state.tabs
                          .map((tabsItem, tabsKey) => {
                            let countWT = 0;
                            let countCCWT = 0;
                            let countScore = 0;
                            let countConpenScore = [];
                            const groupId = this.state.tabs.find(
                              r => r.groupId === tabsItem.groupId
                            ).groupId;
                            const segmentId = this.state.tabs.find(
                              r => r.segmentId === tabsItem.segmentId
                            ).segmentId;
                            return `<div style=" width: 714px; margin-bottom: 20px;height: 300px; ">
                                <div style="margin-bottom: 20px; width: 100%">
                                    <div>
                                        ${tabsItem.groupName}
                                    </div>
                                </div>
                                <div style='width: 400px; float: left;border-right: 2px dashed'>
                                    <div style='width: 100%; height: 30px;'></div>
                                    <table style="width: 100%">
                                        <thead>
                                            <tr style='width: 100%'>
                                                <th style="font-size: 12px; width: 12.5%;">Benefits Sought</th>
                                                <th style="font-size: 12px; width: 12.5%;">WT</th>
                                                <th style="font-size: 12px; width: 12.5%;">Critical Capability</th>
                                                <th style="font-size: 12px; width: 12.5%;">CC WT</th>
                                                <th style="font-size: 12px; width: 12.5%;">Rating <br/> (1-10)</th>
                                                <th style="font-size: 12px; width: 12.5%;">Score</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            ${this.state.competeData &&
                                              !_.isEmpty(
                                                this.state.benefitsData
                                              ) &&
                                              this.state.competeData
                                                .map((i, index) => {
                                                  if (
                                                    tabsItem.groupId ===
                                                      i.groupId &&
                                                    tabsItem.segmentId ===
                                                      i.segmentId
                                                  ) {
                                                    let benefitName;
                                                    this.props.benefits.benefitsLadderData.Items[0].data.map(
                                                      item => {
                                                        if (
                                                          item.groupId ===
                                                          i.groupId
                                                        ) {
                                                          benefitName = item.benefits.find(
                                                            r =>
                                                              r.id ===
                                                                i.benefitId &&
                                                              r.important
                                                          );
                                                        }
                                                      }
                                                    );
                                                    // let benefitName = this.state.benefitsData.find(r => r.groupId === i.groupId && r.benefitId === i.benefitId);
                                                    return `<tr style="width: 100%">
                                                        <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                                            <div className='td-box' style='min-height: 50px'>
                                                                ${
                                                                  benefitName ? benefitName.name : i.name
                                                                }
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                                            <div className='td-box' style=" position : relative; min-height: 50px">
                                                                ${i.wt}
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                                            <div className='td-box' style='min-height: 50px'>
                                                                ${i.criticalCapacity
                                                                  .map(
                                                                    (
                                                                      critItem,
                                                                      index
                                                                    ) => {
                                                                      return `<div> ${
                                                                        critItem.text ? critItem.text : ''
                                                                      } </div>`;
                                                                    }
                                                                  ).join("")}
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                                            <div className='td-box' style='min-height: 50px'>
                                                            ${i.criticalCapacity
                                                              .map(
                                                                (
                                                                  critItem,
                                                                  index
                                                                ) => {
                                                                  let ccWt =
                                                                    i
                                                                      .criticalCapacity
                                                                      .length >
                                                                    1
                                                                      ? critItem.ccWt
                                                                      : critItem.ccWt;

                                                                  return `<div style="position: relative">
                                                                    ${ccWt}
                                                                </div>`;
                                                                }
                                                              ).join("")}
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 11px; width: 16%; text-align: center;  background: #f5f5f6">
                                                            <div className='td-box' style='min-height: 50px'>
                                                                ${i.criticalCapacity
                                                                  .map(
                                                                    (
                                                                      critItem,
                                                                      index
                                                                    ) => {


                                                                      let val = critItem.rating
                                                                        ? critItem.rating
                                                                        : "1";



                                                                      return `<div style="position: relative; ">
                                                                        ${val}

                                                                    </div>`;
                                                                    }
                                                                  ).join("")}
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                                            <div className='td-box' style='min-height: 50px'>
                                                                ${i.criticalCapacity
                                                                  .map(
                                                                    (
                                                                      critItem,
                                                                      index
                                                                    ) => {
                                                                      let valScore = critItem.rating
                                                                        ? +critItem.ccWt *
                                                                          +critItem.rating
                                                                        : +critItem.ccWt;
                                                                      countScore =
                                                                        +countScore +
                                                                        valScore;

                                                                      return `<div className='score-box' style="position: relative">
                                                                            ${valScore}
                                                                        </div>`;
                                                                    }
                                                                  ).join("")}
                                                            </div>
                                                        </td>
                                                    </tr>`;
                                                  }
                                                })
                                                .join("")}

                                            <tr style="width: 100%">
                                                <td style="font-size: 11px; width: 16%; text-align: center"></td>
                                                <td style="font-size: 11px; width: 16%; text-align: center">
                                                    <strong>

                                                    </strong>
                                                </td>
                                                <td style="font-size: 11px; width: 16%; text-align: center"></td>
                                                <td style="font-size: 11px; width: 16%; text-align: center">
                                                    <strong>

                                                    </strong>
                                                </td>
                                                <td style="font-size: 11px; width: 16%; text-align: center"></td>
                                                <td style="font-size: 11px; width: 16%; text-align: center">
                                                    <strong>
                                                        ${countScore}
                                                    </strong>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div style='width: 300px; float: left'>
                                    <div style='width: 300px; height: 30px; margin-left: 10px'>
                                    ${this.state.competeData.find(
                                      r =>
                                        r.groupId === tabsItem.groupId &&
                                        r.segmentId === tabsItem.segmentId
                                    ).competitorTotal &&
                                      _.uniqBy(
                                        this.state.competeData.find(
                                          r =>
                                            r.groupId === tabsItem.groupId &&
                                            r.segmentId === tabsItem.segmentId
                                        ).competitorTotal,
                                        "competitorId"
                                      )
                                        .map((item, index) => {
                                          return `<div style='width: 33%; float: left;'>
                                                ${this.state.competitorsGroupsData
                                                  .map((name, key) => {
                                                    if (
                                                      item.competitorId ===
                                                      name.competitorId
                                                    )
                                                      return name.competitorName;
                                                  }).join("")}
                                                </div>`;
                                        }).join("")}
                                    </div>
                                    <table style="width: 300px; margin-left: -8px" >
                                        <thead style='width: 300px'>
                                            <tr style='width: 100%; padding: 0px;'>
                                                ${this.state.competitorsGroupsData
                                                  .map((name, key) => {
                                                    if (name.important) {
                                                      return `
                                                            <th style='width: 33.3%; padding: 0px;'>
                                                                <th style='width: 49%; font-size: 12px; padding: 0px; text-alight: center'>Rating <br/> (1-10)</th>
                                                                <th style='width: 49%; font-size: 12px; padding: 0px; text-alight: center'>Score</th>
                                                            </th>
                                                        `;
                                                    }
                                                  }).join("")}
                                            </tr>
                                        </thead>
                                        <tbody style="width: 100%">
                                            ${this.state.competeData &&
                                              !_.isEmpty(
                                                this.state.benefitsData
                                              ) &&
                                              this.state.competeData
                                                .map((i, index) => {
                                                  if (
                                                    tabsItem.groupId ===
                                                      i.groupId &&
                                                    tabsItem.segmentId ===
                                                      i.segmentId
                                                  ) {

                                                    return `<tr style="width: 100%">
                                                            ${this.state.competitorsGroupsData
                                                              .map(
                                                                (
                                                                  competitorsData,
                                                                  key
                                                                ) => {
                                                                  if (
                                                                    competitorsData.important
                                                                  ) {
                                                                    return `<td style='width: 33.3%'>
                                                                        <td style='width: 50%; font-size: 11px; text-align: center; background: #f5f5f6; height: 50px; padding-left: 23px ; padding-right: 23px'>
                                                                        ${i.criticalCapacity
                                                                          .map(
                                                                            (
                                                                              critItem,
                                                                              index
                                                                            ) => {
                                                                              let defData = critItem.competitors
                                                                                ? critItem.competitors.find(
                                                                                    r =>
                                                                                      r.competitorId ===
                                                                                      competitorsData.competitorId
                                                                                  )
                                                                                : false;
                                                                              return `<div style="position: relative;">
                                                                            ${
                                                                              defData
                                                                                ? defData.rating
                                                                                : 1
                                                                            }


                                                                            </div>`;
                                                                            }
                                                                          )
                                                                          .join(
                                                                            ""
                                                                          )}
                                                                        </td>
                                                                        <td style='width: 50%; font-size: 11px; text-align: center; background: #f5f5f6;height: 50px'>
                                                                        ${i.criticalCapacity.map((critItem,index) => {

                                                                            let rateVal = critItem.competitors ? critItem.competitors.find(r => r.competitorId === competitorsData.competitorId) : { rating: '1' };


                                                                            let valScore = rateVal ? +critItem.ccWt * +rateVal.rating : +critItem.ccWt;


                                                                            let newVal = valScore ? valScore : critItem.ccWt;

                                                                            countConpenScore.push({
                                                                                score: valScore,
                                                                                competitorId: competitorsData.competitorId,
                                                                            })

                                                                              return `<div style='width: 100%; text-align: center; font-size: 11px; position: relative;'>
                                                                                ${
                                                                                  valScore
                                                                                    ? valScore
                                                                                    : critItem.ccWt
                                                                                }

                                                                            </div> `;
                                                                            }
                                                                          )
                                                                          .join(
                                                                            ""
                                                                          )}
                                                                        </td>

                                                                    </td>
                                                                    `;
                                                                  }
                                                                }
                                                              ).join("")}
                                                        </tr>`;
                                                  }
                                                }).join("")}
                                                <tr class='last-row'>
                                                    ${
                                                        this.state.competitorsGroupsData.map((competitorsData, key) => {
                                                            if (competitorsData.important) {
                                                                let val = 0;
                                                                countConpenScore.map((item, key) => {
                                                                    if (item.competitorId === competitorsData.competitorId) {
                                                                        val = val + +item.score
                                                                    }
                                                                })
                                                                return `<td className='parent-td'>
                                                                <td className='child-td'></td>
                                                                <td className=' child-td first-value'>
                                                                <strong>${val}</strong>
                                                                </td>
                                                            </td>`
                                                            }
                                                        }).join("")

                                                    }
                                                </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>`;
                          })
                          .join("")}
        </div>`;

        rasterizeHTML.drawHTML(html, canvas).then((renderResult) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'pt', 'a4');
            pdf.addImage(imgData, 'JPEG', 0, 0);
            pdf.save('ability.pdf');
        });
    }

    downloadPDF = (e) => {
        this.printDocument(e);
    }

    abilityToCompeteErrorModal = () => {
        this.setState({  abilityToCompeteError : !this.state.abilityToCompeteError })
    }

    componentWillReceiveProps(nextProps) {
        if( nextProps.compete.competeData.Items && _.isEmpty(this.state.competeData) ){

            if (!nextProps.compete.competeFetching && !_.isEmpty(nextProps.compete.competeData.Items) && !_.isEmpty(nextProps.compete.customerSegmentData)) {
                let data =[];
                let tabs = [];

                nextProps.compete.competeData.Items[0].dataBenefits.map(item=>{
                    if(!item.criticalCapacity){
                        let criticalCapacity = [{
                            text: '',
                            ccWt: item.wt
                        }];
                        item.criticalCapacity = criticalCapacity
                    }

                    data.push(item)
                });

                let tabTitleArr = [];
                nextProps.compete.competeData.Items[0].dataBenefits.map(item=>{
                    let customerSegmentItem = nextProps.compete.customerSegmentData.find(r => r.groupId === item.groupId);

                    let segmentData = customerSegmentItem.segments.find(r => r.segmentId === item.segmentId);

                    tabs.push({
                        groupId: item.groupId,
                        groupName: customerSegmentItem.groupName,
                        segmentId: item.segmentId,
                        segmentName: segmentData.name
                        //attractivnessId: uuidv1(),
                    });

                    if(_.isEmpty(nextProps.compete.benefitsData)){
                        let benefitData = {
                            projectId: this.props.projectId,
                            type : 'benefitsLadder',
                            groupId: item.groupId,
                        }
                        this.props.getBenefits(benefitData)
                    }

                });

                this.setState({
                    competeData : data,
                    editedData : true,
                    createdData : false,
                    tabs: _.uniqBy(tabs, v => [v.groupId, v.segmentId].join())
                });
            }

            if( _.isEmpty(nextProps.compete.competeData.Items) && !this.state.createdData){
                this.setState({createdData : true, editedData: false })
            }
        }

        if( nextProps.compete.competitorsGroupsData.Count > 0 &&  nextProps.compete.competitorsGroupsData.Items[0] && nextProps.compete.competitorsGroupsData.Items[0].competitors && !_.isEmpty(nextProps.compete.competitorsGroupsData.Items[0].competitors) && _.isEmpty(this.state.competitorsGroupsData) ) {
            nextProps.compete.competitorsGroupsData.Items[0].competitors.map(item=>{
                this.state.competitorsGroupsData.push({
                    competitorId: item.competitorId,
                    competitorName: item.competitorName,
                    important: item.important,
                    indirect: item.indirect,
                    type: item.type,
                })
            })

            //competitorsGroupsData
        }

        if(nextProps.compete.benefitsData && !_.isEmpty(nextProps.compete.benefitsData) &&  _.isEmpty(this.state.benefitsData)){
            nextProps.compete.benefitsData.res.map(item=>{
                this.state.benefitsData.push({
                    benefitId: item.id,
                    groupId: nextProps.compete.benefitsData.body.groupId,
                    projectId: nextProps.compete.benefitsData.body.projectId,
                    benefitName: item.name,
                })
            })
        }

        if(nextProps.compete.benefitsData && !_.isEmpty(nextProps.compete.benefitsData) && this.state.createNewTabPending ){
            this.state.competeData.map(item=>{
                if(!item.benefitId){
                    nextProps.compete.benefitsData.res.map(benefitsItem=>{
                        if(item.groupId === nextProps.compete.benefitsData.body.groupId){
                            item.benefitId = benefitsItem.id,
                            item.wt = 0
                            this.setState({ createNewTabPending : false })

                        }
                    })
                }
            })
        }

        if(!nextProps.compete.createAbilityOfCompeteFetching  && nextProps.compete.createAbilityOfCompeteData && nextProps.compete.createAbilityOfCompeteData.statusCode === 200 && this.props.groupStepState === 4 && this.state.goNextStep) {
            this.props.groupStateNext();
        }
    }

    accountCCWT = (data) => {
        let numbersArr = [];

        this.state.competeData.map((i,index )=> {
            if( data.groupId === i.groupId && data.segmentId === i.segmentId){
                i.criticalCapacity.map((count,index )=> {
                    return  numbersArr.push({
                                ccWt: count.ccWt,
                            // groupId: i.groupId,
                            //     segmentId: i.segmentId,
                            })
                })
            }

        })
        this.setState({ countCCWT : numbersArr })
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                <div className='rect1'/>
                <div className='rect2'/>
                <div className='rect3'/>
                <div className='rect4'/>
                <div className='rect5'/>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className='criteria-content'>
                <div className='step-bar'>
                    <div className='step step-five arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 3</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 4</p>
                    </div>
                    <div className='step step-five arrow-step active-step'>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className="row">
                      <div className="col-sm-12">
                        <h5>ABILITY TO COMPETE</h5>
                      </div>
                    </div>
                    { !this.props.compete.competeFetching &&
                        <div className='row'>
                            <div className="col-md-12">
                                <div className='card' id="print" ref={el => (this.componentRef = el)}>
                                    <div className='card-header'>
                                      <div className="col-md-8">
                                        <div className="criteria-title-box">
                                          <h5>Results</h5>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='card-body'>
                                      { !this.state.createNewTabPending &&
                                          <WeightBenefitsTabs
                                              tabs={this.state.tabs}
                                              challengeStatementData={this.props.challengeStatement.getChallengeStatementData}
                                              benefitsData={this.state.benefitsData}
                                              competeData={this.state.competeData}
                                              countCCWT={this.state.countCCWT}
                                              competitorsGroupsData={this.state.competitorsGroupsData}
                                              benefits={this.props.benefits}
                                              tabStep={this.props.tabStep}
                                              onTabChange={this.props.onTabChange}
                                              // countWT={this.countWT}
                                              // countCriticalWT={this.countCriticalWT}
                                          />
                                      }
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <Link to={'/prioritizer/'+this.props.projectId} className='btn btn-success'> Next </Link>
                                        <Link to='/toolkit' className='btn btn-success'> Done </Link>
                                        <div className='btn empty-btn default' onClick={this.downloadPDF}>Save PDF</div>
                                        <div className='btn empty-btn default' onClick={this.printPage}>Print</div>
                                        <div className='btn empty-btn default' onClick={() => this.props.groupStateBack()}>Back</div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    { this.props.compete.competeFetching &&
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className="card-body">
                                    {this.elementInfiniteLoad()}
                                </div>
                            </div>
                        </div>
                    }

                    { this.state.abilityToCompeteError &&
                        <AbilityToCompeteError
                            abilityToCompeteErrorModal={this.abilityToCompeteErrorModal}
                        />
                    }
                </div>
            </div>
        )
    }
}
export default (Result);



// WEBPACK FOOTER //
// ./src/components/AbilityToCompete/Result/Result.jsx